import { baseRequestWithHeaders } from './base-request';

export const listCenterOffDates = (centerId) => {
  return baseRequestWithHeaders(`centers/${centerId}/off-dates`, 'GET', null, null);
};

export const addCenterOffDates = (centerId, dates) => {
  return baseRequestWithHeaders(`centers/${centerId}/off-dates`, 'POST', null, { dates });
};

export const removeCenterOffDates = (centerId, dates) => {
  return baseRequestWithHeaders(`centers/${centerId}/off-dates`, 'DELETE', null, { dates });
};
